import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/themeThree/banner01.png'
import _imports_1 from '@/assets/themeThree/crown.png'
import _imports_2 from '@/assets/themeThree/coin.png'
import _imports_3 from '@/assets/bonus/select.png'


const _hoisted_1 = { class: "level_container" }
const _hoisted_2 = { class: "top_card" }
const _hoisted_3 = { class: "top_content" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text_2" }
const _hoisted_6 = { class: "level_scroll_wrapper" }
const _hoisted_7 = { class: "level_list" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { style: {"color":"#737BB2","padding":"15px 0","font-size":"14px"} }
const _hoisted_10 = {
  key: 0,
  class: "manual_level_bar"
}
const _hoisted_11 = { class: "step_label" }
const _hoisted_12 = { class: "middle_container" }
const _hoisted_13 = { class: "label_container" }
const _hoisted_14 = { class: "checked" }
const _hoisted_15 = {
  key: 0,
  src: _imports_3,
  width: "12px",
  alt: ""
}
const _hoisted_16 = {
  key: 0,
  class: "select_icon"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 2,
  class: "activeText",
  style: {"color":"#7a7a7a66","font-weight":"500"}
}
const _hoisted_19 = { class: "bottom_text" }
const _hoisted_20 = { class: "title" }

import { formatCurrency } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import { LevelViewData } from '@/view/level/supportScript';
import { ref } from 'vue'
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'levelView',
  props: {
    dataSet: {}
  },
  emits: ['userRankDailyCheckin'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const isPopping = ref(false)
const isLoading = ref(false)
const router = useRouter()
const emits = __emit
const props = __props

const userRankDailyCheckin = () => {
    emits('userRankDailyCheckin')
}

const clickOnCard = () => {
    isPopping.value = true
    userRankDailyCheckin()
    setTimeout(() => {
        isPopping.value = false
    }, 300)
}

const isLoadingTrue = () => {
    isLoading.value = true
}
const isLoadingFalse = () => {
    isLoading.value = false
}
const navToBack = () => {
    router.go(-1)
}
__expose({
    isLoadingTrue,
    isLoadingFalse
})


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('activityName.user_rank'),
      "is-popup-close-back-icon": true,
      bgColor: "#154084",
      onClosePopup: navToBack
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.dataSet.currentRankIcon ? _ctx.dataSet.currentRankIcon : require('@/assets/themeThree/v0.png'),
            alt: ""
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.dataSet.currentRankName ? _ctx.dataSet.currentRankName : _ctx.$t('rewards.notActivated')), 1),
          _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.levelList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.rank,
              style: {"display":"flex","align-items":"center","justify-content":"center","flex-direction":"column"}
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["level_item", _ctx.dataSet.activeRank >= item.rank ? 'active_level' : ''])
              }, [
                _createElementVNode("img", {
                  src: item.icon2,
                  alt: ""
                }, null, 8, _hoisted_8)
              ], 2),
              _createElementVNode("div", _hoisted_9, _toDisplayString(item.rank_name), 1),
              (_ctx.dataSet.levelList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["step_line left", { active: _ctx.dataSet.activeRank > _ctx.dataSet.levelList[0].rank }])
                    }, null, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["level_step", { active: _ctx.dataSet.activeRank >= item.rank }])
                    }, [
                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "step_dot2" }, [
                        _createElementVNode("div", { class: "step_dot" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(Number(item.turnover_amount)), 1),
                      (index !== _ctx.dataSet.levelList.length - 1)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["step_line", { active: _ctx.dataSet.activeRank >= _ctx.dataSet.levelList[index + 1].rank }])
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[3] || (_cache[3] = _createElementVNode("img", {
          src: _imports_1,
          alt: ""
        }, null, -1)),
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('level.title')), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.rewardsList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "label_text"
          }, [
            _createVNode(_component_van_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "3",
                  class: "checkingDoneTick"
                }, {
                  default: _withCtx(() => [
                    _cache[4] || (_cache[4] = _createElementVNode("img", {
                      src: _imports_2,
                      alt: "",
                      width: "40%"
                    }, null, -1)),
                    _createElementVNode("div", _hoisted_14, [
                      (item.status == 2)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_van_col, {
                  span: "5",
                  class: "day_text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.travel')) + " " + _toDisplayString(item.day), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_van_col, {
                  span: "4",
                  class: "currency_text"
                }, {
                  default: _withCtx(() => [
                    _cache[5] || (_cache[5] = _createTextVNode("R$ ")),
                    _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(Number(item.reward))), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_van_col, {
                  span: "10",
                  offset: "2",
                  class: "label_img"
                }, {
                  default: _withCtx(() => [
                    (item.status == 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[6] || (_cache[6] = [
                          _createElementVNode("img", {
                            src: _imports_3,
                            alt: ""
                          }, null, -1)
                        ])))
                      : _createCommentVNode("", true),
                    (item.status == 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["activeText", { 'pop-animate': isPopping.value }]),
                          onClick: clickOnCard
                        }, [
                          (isLoading.value)
                            ? (_openBlock(), _createBlock(_component_van_loading, {
                                key: 0,
                                size: "15",
                                type: "spinner"
                              }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$t('common.notCompleted')), 1))
                        ], 2))
                      : _createCommentVNode("", true),
                    (item.status == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t('common.notCompleted')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('common.activityTitle')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activityInfo, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "line_text",
            key: index
          }, _toDisplayString(item), 1))
        }), 128))
      ])
    ])
  ], 64))
}
}

})